export const utils = {
  TOGGLE_MENU: 'TOGGLE_MENU'
}

export default { utils }
